export default "__VITE_ASSET__c40ad025__"